import React from "react";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useHistory } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { useTranslation, Trans } from 'react-i18next';


import {
  makeStyles,
} from "@material-ui/core";
import { useEffect } from "react";

const schema = yup.object().shape({
  first_name: yup.string(),
  last_name: yup.string(),
  address: yup.string(),
  contact_number: yup.string(),
  email: yup.string(),
  date_of_birth: yup.string(),
  occupation: yup.string(),
});

const useStylesAll = makeStyles(theme => ({
  priceItem: {
    marginTop: "10px",
  },
  price: {
    marginTop: "10px",
    textAlign: "right",
  },
  priceItemTotal: {
    marginTop: "10px",
    color: "#727272",
  },
  priceTotal: {
    marginTop: "10px",
    textAlign: "right",
    fontWeight: "700",
  },
  field: {
    lineHeight: "25px"
  },
}));

const defaultFormValues = {
  amount: "",
  isReciept: "",
};


function RegisterStep5Page(props) {
  const { currentStep, plan, planList, deliveryMethod, donationAmount, isPromotionPeriod, renewalDiscount, firstName, lastName, address, contactNumber, email, dob, shippingCostPickup, shippingCostDelivery } = props;
  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isReciept, setIsReciept] = React.useState(false);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const history = useHistory();
  const [paymentMethod, setPaymentMethod] = React.useState('CreditCard');
  const [total, setTotal] = React.useState("");
  const [items, setItems] = React.useState(null);

  console.warn('dob', dob)

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });


  const handlePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  const onSubmit = async (value) => {
    // setLoading(true);
    // purge date and time
    const { date, time, ...data } = value;
    try {
      // TODO: update 
      // value
    } catch (e) {
      console.log(e);
    }
    // setLoading(false);
  };

  function ChargingItem(props) {
    const { itemName, itemPrice } = props;
    return (
      <>
        <Grid item xs={8} className={classes.priceItem}>{t(itemName)}</Grid>
        <Grid item xs={4} className={classes.price}>${itemPrice}</Grid>
      </>
    );
  };

  useEffect(()=>{
    if(currentStep == 5){
      var items = [];
      var total = 0;
      planList.forEach(planDetail => {
        if(planDetail.id == plan){
          var planName = planDetail.name;
          var discount = ( isPromotionPeriod && (planDetail.name === 'Classic' || planDetail.name === '會員')) ? parseFloat(renewalDiscount) : 0;
          var planPrice = parseFloat(planDetail.price) - discount;
          items.push(
            {"name": planName,
            "price": planPrice}
          );
          total = total + planPrice;
        }
      });

      if (deliveryMethod !== '2') {
        const shippingCost = deliveryMethod === '0' ? shippingCostPickup : shippingCostDelivery
        items.push(
          {"name": 'shippingcost',
          "price": shippingCost}
        );
        total = total + shippingCost;
      }

      if(!isNaN(donationAmount)) {
        items.push(
          { "name": "donation",
          "price": donationAmount}
        );
        total = total + parseInt(donationAmount);
      }

      setItems(items);
      setTotal(String(total));

    }
  }, [currentStep])

  return (
    currentStep == 5 ?

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h2">{t("overviewsubtitle")}</Typography>

          <Typography variant="body1" className={classes.field} style={{fontWeight: 700, display: 'inline-block'}}>{t('contactnumbermembernum')}:</Typography> <Typography variant="body1" className={classes.field} style={{display: 'inline-block'}}>{contactNumber}</Typography> <Typography variant="body1" className={classes.field} style={{display: 'inline-block'}}>{t('contactnumbermemberremark')}</Typography>
          <Typography variant="body1" className={classes.field}>{t('firstName.label')}: {firstName}</Typography>
          <Typography variant="body1" className={classes.field}>{t('lastName.label')}: {lastName}</Typography>
          <Typography variant="body1" className={classes.field}>{t('address.label')}: {address}</Typography>
          <Typography variant="body1" className={classes.field}>{t('email.label')}: {email}</Typography>
          <Typography variant="body1" className={classes.field}>{t('dob.label')}: {dob.split('-').filter((_, idx) => idx < 2).join('/')}</Typography>

          <Typography variant="h2" style={{ marginBottom: 0, marginTop: "15px" }}>{t("total")}</Typography>
          <Grid container direction="row"
            justifyContent="space-between"
            alignItems="center"
          >

          {items!= null ? Object.keys(items).map(function (key) {
            return (
              <ChargingItem itemName={items[key]['name']} itemPrice={items[key]['price']}/>
              )
          }) : <></>}

            <Grid item xs={12} className={classes.priceItem}>
              <Divider />
            </Grid>

            <Grid item xs={8} className={classes.priceItemTotal}>{t("total")}</Grid>
            <Grid item xs={4} className={classes.priceTotal}>${total}</Grid>

          </Grid>

        </Grid>

        <Grid item xs={12}>
          <Typography variant="h2" style={{ marginBottom: 0 }}>{t('selectpaymentmethod')}</Typography>
          <FormControl component="fieldset" style={{ width: "100%", marginTop: 0 }}>
            <RadioGroup aria-label="paymentMethod" name="paymentMethod" value={paymentMethod} onChange={handlePaymentMethod}>
              <Grid container direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item xs sm={8} className={classes.priceItem}><FormControlLabel value="CreditCard" control={<Radio />} label={t('creditcard')} /></Grid>
                <Grid item xs sm={4} className={classes.price}><CreditCardIcon /></Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      : <></>

  );
}

export default RegisterStep5Page;
